import { ConfirmDialog as PrimeConfirmDialog } from "primereact/confirmdialog";

import { ConfirmFooter } from "./confirm-footer";
import type { ConfirmFooterOptions } from "./confirm-footer";
import type { ConfirmDialogViewProps } from "./types-confirm-dialog";

export function ConfirmDialogView({
  dialogRef,
  dialogProps,
  customFooter,
  onPendingChange,
}: ConfirmDialogViewProps) {
  return (
    <PrimeConfirmDialog
      ref={dialogRef}
      {...dialogProps}
      footer={
        customFooter ??
        ((options) => (
          <ConfirmFooter
            options={options as unknown as ConfirmFooterOptions}
            onPendingChange={onPendingChange}
          />
        ))
      }
    />
  );
}
